import React, { useEffect, useState } from 'react';
import { Text, Button, Icon } from '../../Atoms';
import { InputProfileOrganism } from '../../Organisms';
import { Upload, Modal } from '../../Molecules';
import { ConfirmPasswordModal } from '../../Modals';
import styles from './TemplateHome.module.scss';

function TemplateProfileScreen2Beneficiaire(props) {
  const [windowWidth, setWindowWidth] = useState({
    innerWidth: window.innerWidth
  });
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth({ innerWidth: window.innerWidth });
    });
  }, []);

  const openDeleteModal = () => {
    setShowDeleteUserModal(true);
    props.addParamsInHistory();
  }
  const renderDeleteBeneficiaryModalCompletedContent = () => {
    return (
      <div style={{ height: '100%' }}>
        <div className={styles['medadom-modal-close-container']}>
          <button
            className={styles['medadom-modal-close-btn']}
            onClick={() => props.setShowDeleteBeneficiaryCompleted(false)}
          >
            <Icon
              icon="CloseIcon"
              size={20}
              color="#000"
              className={styles['medadom-modal-close-icon']}
            />
          </button>
        </div>
        <div className={styles['medadom-modal-content-container']}>

          <div className={styles['medadom-modal-title']}>
            {/* <span>{{ props.showDeleteBeneficiaryMessage }}</span> */}
            <Text style={{ 'font-size': '16px', 'line-height': 'normal' }}
              text={props.showDeleteBeneficiaryMessage}
            />
          </div>
          <div>
            <button
              className={styles['medadom-modal-btn']}
              onClick={() => props.setShowDeleteBeneficiaryCompleted(false)}
            >
              Ok
            </button>
          </div></div>

      </div>
    );
  };

  const renderDeleteBeneficiaryModalContent = () => {
    return (
      <div style={{ height: '100%' }}>
        <div className={styles['medadom-modal-close-container']}>
          <button
            className={styles['medadom-modal-close-btn']}
            onClick={() => setShowDeleteUserModal(false)}
          >
            <Icon
              icon="CloseIcon"
              size={20}
              color="#000"
              className={styles['medadom-modal-close-icon']}
            />
          </button>
        </div>
        <div className={styles['medadom-modal-content-container']}>

          <div className={styles['medadom-modal-title']}>
            Êtes-vous sûr de vouloir supprimer ce bénéficiaire?
          </div>
          <div>
            <button
              className={styles['medadom-modal-second-btn']}
              onClick={() => { setShowDeleteUserModal(false) }}
            >
              Annuler
            </button>
            <button
              className={styles['medadom-modal-btn']}
              onClick={() => { setShowDeleteUserModal(false); props.handleDeleteBeneficiary() }}
            >
              Oui
            </button>
          </div></div>

      </div>
    );
  };
  return (
    <div className='template-scroll cartetp-container'>
      <Modal
        show={showDeleteUserModal}
        onHide={setShowDeleteUserModal}
        dialogClassName={styles['medadom-modal-container']}
        contentClassName={styles['medadom-modal']}
        showIconClose={false}
        size={'larg-medium'}
      >
        {renderDeleteBeneficiaryModalContent()}
      </Modal>
      <Modal
        show={props.showDeleteBeneficiaryCompleted}
        onHide={() => props.setShowDeleteBeneficiaryCompleted(false)}
        dialogClassName={styles['medadom-modal-container']}
        contentClassName={styles['medadom-modal']}
        showIconClose={false}
        size={'larg-medium'}
      >
        {renderDeleteBeneficiaryModalCompletedContent()}
      </Modal>
      <div className='cartetp-header-container profile-header-container'>
        <Text text='Profil' type='h4' />
        <div className='profile-header-icon-container'>
          <Icon
            icon='SortTop'
            className='profile-header-icon'
            size='20px'
            onClick={props.onIconClick}
          />
        </div>
      </div>
      <div className='first-line-container-profile mt-16'>
        <div className='item-col-profile item-col-profile-margin-left'>
          <div className='col-profile input-profile-container__edit-width'>
            <Text
              text='Informations personnelles'
              className='profile-sub-title'
            />
          </div>
        </div>
        <div className='item-col-profile item-col-profile-margin-right input-profile-container__edit-width-display '>
          <div className='ml-a'>
            <Button
              text='Supprimer le bénéficiaire'
              className='btn-beneficier-profile'
              style={{ width: "197px" }}
              boxShadow
              onClick={() => openDeleteModal()}
            />
          </div>
        </div>
      </div>

      <div>
        <div className='mb-10'>
          <InputProfileOrganism
            value={props.data.title}
            onChange={value => props.onChange(value, 'name')}
            classNameContainer='profile-title-container'
            classNameInput='profile-title-text'
          />
        </div>
        <div className='first-line-container-profile'>
          <div className='item-col-profile item-col-profile-margin-left'>
            <div className='col-profile'>
              <InputProfileOrganism
                label={'Nom'}
                value={props.data.lastName}
                onChange={value => props.onChange(value, 'lastName')}
              />
            </div>
          </div>
          <div className='item-col-profile item-col-profile-margin-right'>
            <InputProfileOrganism
              label={'Type de beneficiaire'}
              value={props.data.typeBeneficiaire}
              onChange={value => props.onChange(value, 'typeBeneficiaire')}
            />
          </div>
        </div>
        <div className='second-line-container-profile'>
          <div className='col-profile second-items-container-profile'>
            <div className='item-col-profile item-col-profile-margin-right mt-10'>
              <InputProfileOrganism
                label={'Prénom'}
                value={props.data.name}
                onChange={value => props.onChange(value, 'name')}
              />
            </div>
            <div className='col-input-container-profile item-col-profile item-col-profile-margin-left'>
              <InputProfileOrganism
                label={'N°Sécurité Sociale'}
                value={props.data.numeroSecuriteSociale}
                onChange={value =>
                  props.onChange(value, 'numeroSecuriteSociale')
                }
              />
            </div>
          </div>
          <div>
            <div className='col-input-container-profile item-col-profile item-col-profile-margin-left'>
              <InputProfileOrganism
                label={'Date de naissance'}
                value={
                  props.data.birthDate
                }
                onChange={value => props.onChange(value, 'birthDate')}
              />
            </div>
            <div className='item-col-profile item-col-profile-margin-right col-input-container-profile'>
              <InputProfileOrganism
                label={'Organisme de rattachement'}
                value={props.data.rattachement}
                onChange={value => props.onChange(value, 'rattachement')}
              />
              {props.editAdress && !props.manuelAddressEdit && (
                <div className='btn-edit-manuelle-adresse-profile-container'>
                  <Button
                    text='Saisie manuelle'
                    className='btn-edit-manuelle-adresse-profile'
                    onClick={() => props.handelManuelAddressEdit(true)}
                  />
                </div>
              )}
              {props.manuelAddressEdit && (
                <div className='ville-cp-input-container'>
                  <div className='item-col-profile item-col-profile-margin-left'>
                    <InputProfileOrganism
                      edit={true}
                      label={'Code postal'}
                      value={props.data.cp}
                      onChange={value => props.onChange(value, 'cp')}
                      {...(window.innerWidth > 768 && {
                        classNameContainer: 'input-ville-profile-container'
                      })}
                      {...(window.innerWidth > 768 && {
                        classNameInput: 'input-ville-profile'
                      })}
                    />
                  </div>
                  <div className='item-col-profile item-col-profile-margin-right'>
                    <InputProfileOrganism
                      edit={true}
                      label={'Ville'}
                      value={props.data.ville}
                      onChange={value => props.onChange(value, 'ville')}
                      {...(window.innerWidth > 768 && {
                        classNameContainer: 'input-ville-profile-container'
                      })}
                      {...(window.innerWidth > 768 && {
                        classNameInput: 'input-ville-profile'
                      })}
                    />
                  </div>
                </div>
              )}
              {props.editAdress && (
                <Upload
                  handleFileChange={props.selectFile}
                  contentClassName='upload-file-add-beneficiaire-profile-input'
                  classNameText='upload-text-add-beneficiaire-profile'
                  {...(window.innerWidth > 768 && {
                    child: (
                      <div className='btn-upload-container-profile'>
                        <div className='upload-doc-adresse-profile'>
                          <Text
                            text='Justificatif-domicile.pdf'
                            className='placeholder-upload-doc-profile'
                          />
                          <Icon icon='Plus' size={14} />
                        </div>
                        <Text
                          text='PDF, JPEG -  5mo maximum autorisé'
                          className='condition-upload-doc-profile'
                        />
                      </div>
                    )
                  })}
                />
              )}

              {(props.editAdress ||
                (props.oldtel != props.data.tel && window.innerWidth <= 768) ||
                (props.oldMail != props.data.mail &&
                  window.innerWidth <= 768)) && (
                  <div className='btn-commit-edit-adresse-profile-big-container'>
                    <div className='btn-commit-edit-adresse-profile-container'>
                      <Button
                        text='Valider'
                        className='btn-submit-edit-adresse-profile'
                        onClick={() =>
                          !props.editAdress
                            ? props.showModal()
                            : props.handelEditAdresse(false)
                        }
                      />
                      <Button
                        text='Annuler'
                        className='btn-cancel-edit-adresse-profile'
                        onClick={() => props.handelEditAdresse(false)}
                      />
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <div className='profile-title-bank'>
        <Text text='Informations bancaires' className='profile-sub-title' />
      </div>
      <div className='profile-btn-bank-type'>
        <Button
          text='Remboursements'
          className={
            props.data.remboursement
              ? 'btn-radio-bank-profile-selected'
              : 'btn-radio-bank-profile-unselected'
          }
          boxShadow
          onClick={() => props.onChangeBankType('remboursement')}
        />
        <Button
          text='Prélèvements'
          className={
            props.data.prelevement
              ? 'btn-radio-bank-profile-selected'
              : 'btn-radio-bank-profile-unselected'
          }
          boxShadow
          onClick={() => props.onChangeBankType('prelevement')}
        />
      </div>
      <div className='row-profile'>
        <div>
          <div className='line-edit-bank-profile'>
            <div className='col-profile'>
              <InputProfileOrganism
                label={'Propriétaire du compte'}
                value={props.data.accountOwner}
                edit={props.editBank}
                onChange={value => props.onChange(value, 'accountOwner')}
              />
            </div>
            <div className='name-bank-container'>
              {/* <InputProfileOrganism
                label={'Nom de la banque'}
                value={props.data.bankName}
                edit={props.editBank}
                onChange={value => props.onChange(value, 'bankName')}
              /> */}
              <div className=''>
                <InputProfileOrganism
                  label={'BIC'}
                  value={props.data.bic}
                  edit={props.editBank}
                  onChange={value => props.onChange(value, 'bic')}
                />
              </div>
            </div>
          </div>
          <div className='line-edit-bank-profile'>
            <div className='col-profile'>
              <div className='col-input-container-profile'>
                <InputProfileOrganism
                  label={'IBAN'}
                  value={props.data.iban}
                  edit={props.editBank}
                  onChange={value => props.onChange(value, 'iban')}
                />
              </div>
            </div>
            <div>

            </div>
          </div>
          <div className='line-edit-bank-profile'>
            <div className='col-profile'>
              {props.editBank && (
                <Upload
                  handleFileChange={props.selectFile}
                  contentClassName='upload-file-add-beneficiaire-profile-input'
                  classNameText='upload-text-add-beneficiaire-profile'
                  {...(window.innerWidth > 768 && {
                    child: (
                      <div className='btn-upload-container-profile-edit-bank'>
                        <div className='upload-doc-adresse-profile'>
                          <Text
                            text='Veuillez joindre un RIB (obligatoire)'
                            className='placeholder-upload-doc-profile'
                          />
                          <Icon icon='Plus' size={14} />
                        </div>
                      </div>
                    )
                  })}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {
        props.showConfirmationModal && (
          <ConfirmPasswordModal
            show={props.showConfirmationModal}
            onHide={props.onHide}
            modalStep={props.verificationSteps}
            title='Validation des modifications'
            firstText={`Nous venons d’envoyer un code par ${props.editTel
              ? `email à l’adresse  ${props.data.mail}`
              : `SMS au ${props.data.tel}`
              }`}
            secondText='Veuillez le renseigner ci-dessous pour confirmer les modifications :'
            onConfirmCode={() => props.onConfirmCode()}
            onCancel={() => props.onHide()}
            successText='Vos modifications ont été enregistrées.'
            classNameBtncancel='btn-cancel-modal-edit-profile'
            classNameBtnSubmit='btn-submit-modal-edit-profile'
            classNameInput='input-modal-edit-profile'
            onChange={e => props.onChangeCode(e.target.value)}
            code={props.code}
          />
        )
      }
    </div >
  );
}

export default TemplateProfileScreen2Beneficiaire;
